import axios, { AxiosHeaders } from 'axios';
import { env } from '@/config/env';

/** One transport instance; individual API clients may override baseURL for tests. */
export const httpClient = axios.create({
  baseURL: env.apiBaseUrl,
  withCredentials: true,
  timeout: 180_000,
  validateStatus: () => true,
  // Parse only when the response advertises JSON, matching the former fetch client.
  transformResponse: [(data) => data],
});
export { AxiosHeaders };
